module.exports = __webpack_public_path__ + "img/logo-PLP-tmp.84535563.svg";